import { setStyles } from './dom';
import { loadAllWebFonts } from './fonts';
import { loadImgTag } from './loadImgTag';
import { loadLinkTag } from './loadLinkTag';
import { loadScriptTag } from './loadScriptTag';
/**
 * Load all assets (script, css, fonts, images) for the app initiation
 */
export const loadAllAssets = (assetMap, webFontConfig) => {
    const assetContainerId = 'hidden-assets';
    const hiddenAssetContainer = createHiddenAssetContainer(assetContainerId);
    // Assets
    const assetPromises = assetMap.map(asset => {
        const { type, url } = asset;
        if (type === 'script') {
            return loadScriptTag(url);
        }
        if (type === 'css') {
            return loadLinkTag(url);
        }
        return loadImgTag(url, `#${assetContainerId}`);
    });
    // fonts
    const fontPromise = loadAllWebFonts(webFontConfig);
    // combine all promises
    const allPromises = assetPromises.concat(fontPromise);
    return Promise.all(allPromises).then(() => hiddenAssetContainer.parentNode.removeChild(hiddenAssetContainer));
};
/**
 * Create a hidden container to store loaded images
 */
const createHiddenAssetContainer = (id) => {
    const hiddenElement = document.createElement('div');
    setStyles(hiddenElement, {
        width: '1px',
        height: '1px',
        display: 'none',
        overflow: 'hidden',
    });
    hiddenElement.id = id;
    document.body.appendChild(hiddenElement);
    return hiddenElement;
};
